import React, { isValidElement } from 'react';

const getChildrenTypes = (children, options) => {
  const reactNodeList = React.Children.toArray(children);
  const reactElementList = reactNodeList.filter(isValidElement);
  const childrenTypeList = reactElementList.map(child => child.type);
  const deepChildrenTypeList = options.searchDeep ? reactElementList.flatMap(child => getChildrenTypes(child.props.children, options)) : [];
  return [...childrenTypeList, ...deepChildrenTypeList];
};
/**
 * 대상 컴포넌트가 children에 존재하는지 검사합니다.
 * @param {boolean} options.searchDeep - true로 설정하면, 1depth 초과의 deep children까지 모두 검사합니다.
 */
const hasChildComponent = (_ref, options) => {
  let {
    children,
    targetComponent
  } = _ref;
  const {
    searchDeep = false
  } = options ?? {};
  const displayNameSet = new Set(getChildrenTypes(children, {
    searchDeep
  }));
  return Array.isArray(targetComponent) ? targetComponent.some(component => displayNameSet.has(component)) : displayNameSet.has(targetComponent);
};

export { getChildrenTypes, hasChildComponent };
